import { render, staticRenderFns } from "./PrevBack.vue?vue&type=template&id=d0a1e866&scoped=true&lang=pug&"
import script from "./PrevBack.vue?vue&type=script&lang=ts&"
export * from "./PrevBack.vue?vue&type=script&lang=ts&"
import style0 from "./PrevBack.vue?vue&type=style&index=0&id=d0a1e866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a1e866",
  null
  
)

export default component.exports